var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "_bxsh--base _rounded--common _bgc--white _fo",
      attrs: { role: "list" },
    },
    _vm._l(_vm.items, function (item) {
      return _c("base-collapsible", {
        key: `item-${item.name}`,
        attrs: {
          value: _vm.openKey === item.name,
          "is-controlled": "",
          role: "listitem",
          "data-qa": `box-list-item:${item.name}`,
        },
        on: { input: (val) => _vm.onToggle(item.name, val) },
        scopedSlots: _vm._u(
          [
            {
              key: "trigger",
              fn: function ({ isExpanded }) {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "_pa-2 _w-100 _bdb--thick _bc--light _flex _ai-c",
                      attrs: { "aria-expanded": isExpanded },
                    },
                    [
                      _c("base-icon", {
                        staticClass: "_tc--accent",
                        attrs: {
                          name: isExpanded ? "chevron-down" : "chevron-right",
                          size: "lg",
                          "aria-hidden": "true",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: ["_ml-1 _fw-b", { "_tc--accent": isExpanded }],
                          attrs: {
                            role: "heading",
                            "aria-level": "3",
                            "data-qa": "box-list-item-name",
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.name) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "content",
              fn: function () {
                return _vm._l(item.subItems, function (subitem) {
                  return _c(
                    "a",
                    {
                      key: subitem.name,
                      staticClass:
                        "_flex _gap-2 _ai-c _pl-7 _pr-2 _py-2 _tdh-n gfu-link gfu-link--nofx _bdb--thick _bc--light",
                      attrs: {
                        href: subitem.url,
                        "data-qa": `box-list-subitem:${subitem.name}`,
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "_grow-1 _fw-b",
                          attrs: { "data-qa": "box-list-subitem-name" },
                        },
                        [_vm._v(_vm._s(subitem.name))]
                      ),
                    ]
                  )
                })
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }